__turbopack_context__.v({
  "announcement": "secondary-site-module__VMt6hW__announcement",
  "art": "secondary-site-module__VMt6hW__art",
  "artArrow": "secondary-site-module__VMt6hW__artArrow",
  "artLabel": "secondary-site-module__VMt6hW__artLabel",
  "artLines": "secondary-site-module__VMt6hW__artLines",
  "artNumber": "secondary-site-module__VMt6hW__artNumber",
  "articleBody": "secondary-site-module__VMt6hW__articleBody",
  "articleHeader": "secondary-site-module__VMt6hW__articleHeader",
  "articleLayout": "secondary-site-module__VMt6hW__articleLayout",
  "bodySection": "secondary-site-module__VMt6hW__bodySection",
  "breadcrumbs": "secondary-site-module__VMt6hW__breadcrumbs",
  "button": "secondary-site-module__VMt6hW__button",
  "changeEntry": "secondary-site-module__VMt6hW__changeEntry",
  "changeLinks": "secondary-site-module__VMt6hW__changeLinks",
  "code": "secondary-site-module__VMt6hW__code",
  "contents": "secondary-site-module__VMt6hW__contents",
  "cta": "secondary-site-module__VMt6hW__cta",
  "detailIntro": "secondary-site-module__VMt6hW__detailIntro",
  "directory": "secondary-site-module__VMt6hW__directory",
  "directoryAction": "secondary-site-module__VMt6hW__directoryAction",
  "eyebrow": "secondary-site-module__VMt6hW__eyebrow",
  "featured": "secondary-site-module__VMt6hW__featured",
  "featuredCopy": "secondary-site-module__VMt6hW__featuredCopy",
  "included": "secondary-site-module__VMt6hW__included",
  "indexHead": "secondary-site-module__VMt6hW__indexHead",
  "introGrid": "secondary-site-module__VMt6hW__introGrid",
  "liveContent": "secondary-site-module__VMt6hW__liveContent",
  "livePage": "secondary-site-module__VMt6hW__livePage",
  "main": "secondary-site-module__VMt6hW__main",
  "masthead": "secondary-site-module__VMt6hW__masthead",
  "metadata": "secondary-site-module__VMt6hW__metadata",
  "page": "secondary-site-module__VMt6hW__page",
  "questions": "secondary-site-module__VMt6hW__questions",
  "readLink": "secondary-site-module__VMt6hW__readLink",
  "readingProgress": "secondary-site-module__VMt6hW__readingProgress",
  "related": "secondary-site-module__VMt6hW__related",
  "row": "secondary-site-module__VMt6hW__row",
  "rowArrow": "secondary-site-module__VMt6hW__rowArrow",
  "rowNumber": "secondary-site-module__VMt6hW__rowNumber",
  "rows": "secondary-site-module__VMt6hW__rows",
  "shortAnswer": "secondary-site-module__VMt6hW__shortAnswer",
  "tableScroll": "secondary-site-module__VMt6hW__tableScroll",
  "tagline": "secondary-site-module__VMt6hW__tagline",
  "topicBlurb": "secondary-site-module__VMt6hW__topicBlurb",
  "topicNav": "secondary-site-module__VMt6hW__topicNav",
  "topicSection": "secondary-site-module__VMt6hW__topicSection",
  "verdict": "secondary-site-module__VMt6hW__verdict",
});
